export default "__VITE_ASSET__05111783__"